const $$ = (sel, root = document) => root.querySelectorAll(sel);
const on = (sel, evt, fn) => $$(sel).forEach((el) => el.addEventListener(evt, fn));
const activate = (el, cls = 'active') => {
  [...el.parentElement.children].forEach((sib) => sib.classList.toggle(cls, sib === el));
};

// Product info tabs
on('.info-tab-item', 'click', function () {
  activate(this);
  const content = document.getElementById('tab_content_' + this.dataset.id);
  if (content) activate(content, 'show');
});

// Mobile menu open / close
const toggleMenu = (open) => $$('.mobile-menu, .mobile-menu-overlay').forEach((el) => el.classList.toggle('show', open));
on('.mobile-menu-icon', 'click', () => toggleMenu(true));
on('.nav-close, .mobile-menu-overlay', 'click', () => toggleMenu(false));

// Mobile submenu accordion (replaces jQuery slideToggle)
on('.submenu-heading', 'click', function () {
  const panel = this.nextElementSibling;
  if (!panel) return;
  const opening = getComputedStyle(panel).display === 'none';
  this.classList.toggle('active', opening);
  panel.style.display = 'block';
  const h = panel.scrollHeight + 'px';
  panel.style.overflow = 'hidden';
  panel.animate({ height: opening ? ['0px', h] : [h, '0px'] }, { duration: 300, easing: 'ease' }).onfinish = () => {
    panel.style.overflow = '';
    panel.style.display = opening ? 'block' : 'none';
  };
});

// Mobile menu tabs (Categories / Main Menu)
on('.mobile-category', 'click', function () {
  activate(this);
  const target = document.getElementById(this.dataset.id);
  if (target) [...target.parentElement.children].forEach((el) => (el.style.display = el === target ? '' : 'none'));
});

// Brand filter: wheel scroll, drag to scroll, prev / next arrows.
// facets.js re-renders #ProductGridContainer (which holds the bar) on every filter / sort change,
// so bars are (re)initialised on load and whenever that container's content is replaced.
let drag = null, dragMoved = false;

document.addEventListener('mouseup', () => {
  if (!drag) return;
  drag.bar.classList.remove('dragging');
  drag = null;
});

document.addEventListener('mousemove', (e) => {
  if (!drag) return;
  e.preventDefault();
  const walk = e.pageX - drag.startX;
  if (Math.abs(walk) > 5) dragMoved = true;
  drag.bar.scrollLeft = drag.startLeft - walk;
});

const initBrandBar = (bar) => {
  if (bar.dataset.ready) return;
  bar.dataset.ready = 'true';

  bar.addEventListener('wheel', (e) => {
    if (!e.deltaY) return;
    bar.scrollLeft += e.deltaY;
    e.preventDefault();
  }, { passive: false });

  bar.addEventListener('dragstart', (e) => e.target.closest('img') && e.preventDefault());

  bar.addEventListener('mousedown', (e) => {
    drag = { bar, startX: e.pageX, startLeft: bar.scrollLeft };
    dragMoved = false;
    bar.classList.add('dragging');
  });

  bar.addEventListener('click', (e) => dragMoved && e.target.closest('a') && e.preventDefault());

  // Arrows hide at either end (bar is row-reverse, so scrollLeft runs from -max to 0)
  const prev = bar.parentElement.querySelector('.brand-arrow--prev');
  const next = bar.parentElement.querySelector('.brand-arrow--next');
  if (!prev || !next) return;
  const reverse = getComputedStyle(bar).flexDirection === 'row-reverse';
  const update = () => {
    // read everything first, then write, so toggling `hidden` doesn't force a second layout
    const max = bar.scrollWidth - bar.clientWidth;
    const left = bar.scrollLeft;
    const min = reverse ? -max : 0;
    prev.hidden = left <= min + 1;
    next.hidden = left >= min + max - 1;
  };
  prev.addEventListener('click', () => bar.scrollBy({ left: -bar.clientWidth * 0.8 }));
  next.addEventListener('click', () => bar.scrollBy({ left: bar.clientWidth * 0.8 }));
  bar.addEventListener('scroll', update, { passive: true });
  bar.addEventListener('load', update, true); // logo images change the scroll width as they load
  new ResizeObserver(update).observe(bar);
};

const initBrandBars = () => $$('.brand-filter').forEach(initBrandBar);
initBrandBars();
const grid = document.getElementById('ProductGridContainer');
if (grid) new MutationObserver(initBrandBars).observe(grid, { childList: true, subtree: true });
